import { configureStore } from "@reduxjs/toolkit";
import ExampleReducer from "./slice/exampleSlice";

export const store = configureStore({
  reducer: {
    Example: ExampleReducer,
  },
});
